import { c as _c } from "react/compiler-runtime";
import { Modal, PrimaryButton, RadioGroup, RadioGroupDataInterface, toast } from '@systemeio/ui';
import { BadRequest, ErrorResponseContentInterface } from '@systemeio/util';
import FormSenderEmailInput from 'modules/email/components/form-sender-email-input';
import { useSendTestEmail } from 'modules/mailing/hooks/use-send-test-email';
import { useMailingSettings } from 'modules/profile/mailing-settings/hooks/use-mailing-settings';
import { MailingSettingsInterface } from 'modules/profile/mailing-settings/types/mailing-settings-interface';
import React, { useEffect, useState } from 'react';
import { useMailingState } from 'shared/components/dashboard-mail-editor/hooks/use-mailing-state';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { HTMLString } from 'shared/types/html-string';
interface SaveAndTestSplitTestProps {
  opened: boolean;
  onClose: () => void;
  onSave: () => Promise<void>;
  variantA: ReturnType<typeof useMailingState>;
  variantB: ReturnType<typeof useMailingState>;
}
export function SaveAndTestSplitTest(t0) {
  const $ = _c(68);
  const {
    onClose,
    opened,
    onSave,
    variantA,
    variantB
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [email, setEmail] = useState(null);
  const [hasEmailBeenChanged, setHasEmailBeenChanged] = useState(false);
  const [error, setError] = useState(null);
  const [mailingId, setMailingId] = useState();
  const [isFetching, setIsFetching] = useState(false);
  const {
    fetcherSendTestEmail
  } = useSendTestEmail();
  const {
    mailingData
  } = useMailingSettings();
  const t1 = variantA.mailing.id;
  let t2;
  if ($[0] !== t) {
    t2 = t("dashboard.newsletter_editor.split_test.variant_a");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2 || $[3] !== variantA.mailing.id) {
    t3 = {
      id: t1,
      caption: t2
    };
    $[2] = t2;
    $[3] = variantA.mailing.id;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = variantB.mailing.id;
  let t5;
  if ($[5] !== t) {
    t5 = t("dashboard.newsletter_editor.split_test.variant_b");
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5 || $[8] !== variantB.mailing.id) {
    t6 = {
      id: t4,
      caption: t5
    };
    $[7] = t5;
    $[8] = variantB.mailing.id;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = [t3, t6];
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const variantsData = t7;
  let t8;
  if ($[13] !== onClose) {
    t8 = () => {
      onClose();
    };
    $[13] = onClose;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const handelClose = t8;
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      setError(null);
      setMailingId(undefined);
      setEmail(null);
      setHasEmailBeenChanged(false);
    };
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const afterLeave = t9;
  let t10;
  if ($[16] !== email || $[17] !== fetcherSendTestEmail || $[18] !== mailingId || $[19] !== onClose || $[20] !== onSave) {
    t10 = async () => {
      if (!email || !mailingId) {
        return;
      }
      setIsFetching(true);
      ;
      try {
        await onSave();
        await fetcherSendTestEmail(mailingId, {
          email
        });
        onClose();
      } catch (t11) {
        const e = t11;
        if (e instanceof BadRequest) {
          const errors = e.errors as ErrorResponseContentInterface<{
            email: HTMLString[];
          }>;
          if (errors?.fields?.email) {
            setError(errors.fields.email.join(""));
          }
          if (errors.common?.length) {
            toast.error(<p className="[&>a]:primary-link" dangerouslySetInnerHTML={{
              __html: errors.common.join("")
            }} />);
          }
        }
      }
      setIsFetching(false);
    };
    $[16] = email;
    $[17] = fetcherSendTestEmail;
    $[18] = mailingId;
    $[19] = onClose;
    $[20] = onSave;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const handleConfirm = t10;
  let t11;
  if ($[22] !== email || $[23] !== hasEmailBeenChanged || $[24] !== mailingData) {
    t11 = () => {
      if (!hasEmailBeenChanged && !email && mailingData) {
        setEmail(mailingData.testEmailAddress);
      }
    };
    $[22] = email;
    $[23] = hasEmailBeenChanged;
    $[24] = mailingData;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const t12 = mailingData?.testEmailAddress;
  let t13;
  if ($[26] !== email || $[27] !== hasEmailBeenChanged || $[28] !== mailingData || $[29] !== t12) {
    t13 = [email, hasEmailBeenChanged, mailingData, t12];
    $[26] = email;
    $[27] = hasEmailBeenChanged;
    $[28] = mailingData;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  useEffect(t11, t13);
  let t14;
  if ($[31] !== t) {
    t14 = t("dashboard.newsletter_editor.send_test_modal_title");
    $[31] = t;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  const t15 = email || "";
  const t16 = !mailingData;
  let t17;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = e_0 => {
      setHasEmailBeenChanged(true);
      setEmail(e_0.target.value);
    };
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t) {
    t18 = t("dashboard.email.test_email_address");
    $[34] = t;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== error || $[37] !== t15 || $[38] !== t16 || $[39] !== t18) {
    t19 = <FormSenderEmailInput value={t15} className="w-full" key="email" isPreFetching={t16} onChange={t17} htmlFor="none" label={t18} required={true} error={error} />;
    $[36] = error;
    $[37] = t15;
    $[38] = t16;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t) {
    t20 = t("dashboard.newsletter_editor.split_test.save_and_test.selected_variant");
    $[41] = t;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== mailingId || $[44] !== t20 || $[45] !== variantsData) {
    t21 = <div className="flex justify-center"><RadioGroup className="items-center" label={t20} options={variantsData} selected={mailingId} onChange={setMailingId} /></div>;
    $[43] = mailingId;
    $[44] = t20;
    $[45] = variantsData;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t19 || $[48] !== t21) {
    t22 = <div className="flex flex-col gap-5">{t19}{t21}</div>;
    $[47] = t19;
    $[48] = t21;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  const t23 = !mailingData || !email || !mailingId;
  let t24;
  if ($[50] !== handleConfirm) {
    t24 = e_1 => {
      e_1.preventDefault();
      handleConfirm();
    };
    $[50] = handleConfirm;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t) {
    t25 = t("global.confirm");
    $[52] = t;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== isFetching || $[55] !== t23 || $[56] !== t24 || $[57] !== t25) {
    t26 = <div className="flex justify-center"><PrimaryButton isFetching={isFetching} disabled={t23} width="large" onClick={t24} type="submit">{t25}</PrimaryButton></div>;
    $[54] = isFetching;
    $[55] = t23;
    $[56] = t24;
    $[57] = t25;
    $[58] = t26;
  } else {
    t26 = $[58];
  }
  let t27;
  if ($[59] !== t22 || $[60] !== t26) {
    t27 = <form className="m-auto flex w-full flex-col gap-6 lg:gap-10">{t22}{t26}</form>;
    $[59] = t22;
    $[60] = t26;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  let t28;
  if ($[62] !== handelClose || $[63] !== isFetching || $[64] !== opened || $[65] !== t14 || $[66] !== t27) {
    t28 = <Modal afterLeave={afterLeave} isFetching={isFetching} isCentered={true} opened={opened} onClose={handelClose} title={t14}>{t27}</Modal>;
    $[62] = handelClose;
    $[63] = isFetching;
    $[64] = opened;
    $[65] = t14;
    $[66] = t27;
    $[67] = t28;
  } else {
    t28 = $[67];
  }
  return t28;
}